import { Card, Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { CompetencyMapWithProgressInfo } from "../../ProgressInfo/types";
import ChipInfo from "./ChipInfo";
import Controls from "./Controls";
import InfoForm from "./InfoForm";

interface HeaderCardProps {
  disabled: boolean;
  isCreate: boolean;
  isEditable: boolean;
  competencyMapWithProgressInfo: CompetencyMapWithProgressInfo | undefined;
  setIsEditable: Dispatch<SetStateAction<boolean>>;
}

const HeaderCard = ({
  disabled,
  isCreate,
  isEditable,
  competencyMapWithProgressInfo,
  setIsEditable,
}: HeaderCardProps) => {
  return (
    <Card sx={{ py: 1.5 }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent='space-between'
        spacing={2}>
        <InfoForm isEditable={isEditable} />
        <Stack
          spacing={1.5}
          alignItems='flex-end'>
          <Controls
            disabled={disabled}
            isCreate={isCreate}
            competencyMap={competencyMapWithProgressInfo}
            setIsEditable={setIsEditable}
          />
          {!isCreate && <ChipInfo competencyMapWithProgressInfo={competencyMapWithProgressInfo} />}
        </Stack>
      </Stack>
    </Card>
  );
};

export default HeaderCard;
